var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.state, attrs: { "data-component": "base-common-content" } },
    [
      _vm.useSearch || !!_vm.$slots["search"]
        ? _c(
            "div",
            { staticClass: "header" },
            [
              _vm._t("search"),
              _vm._v(" "),
              _vm.useSearch && !_vm.$slots["search"]
                ? _c("base-search-input", {
                    attrs: {
                      search: _vm.search,
                      placeholder: _vm.placeholder,
                      size: _vm.size,
                      "is-disabled": _vm.isLoading,
                    },
                    on: {
                      "search-change": function ($event) {
                        return _vm.$emit("search-change", $event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content",
          class: { "is-loading": _vm.isLoading || _vm.isSearching },
        },
        [
          _vm.isLoading || _vm.isSearching
            ? _c("or-progress", { attrs: { type: "circle", loading: "" } })
            : [
                _vm._t("append"),
                _vm._v(" "),
                _vm._t("default"),
                _vm._v(" "),
                _vm.canShowOptions
                  ? _vm._l(_vm.options, function (option) {
                      return _c(
                        "div",
                        {
                          key: option[_vm.dataKey],
                          staticClass: "option-wrapper",
                        },
                        [_vm._t("option", null, { option: option })],
                        2
                      )
                    })
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }